import putPostRequestInterface from "./putPostRequestInterface";
import { AxiosInstance, uuid } from "./AxiosRequest";
import getRequestInterface from "./getRequestInterface";
import deleteRequestInterface from "./deleteRequestInterface";
import axios from "axios";
import {
  BASE_URL,
  GET_STUDENT_KUNDALI,
} from "utilFunctions/Constants/urlConstants";

const putPostRequest = async ({
  url,
  success,
  failure,
  body,
  method,
}: putPostRequestInterface) => {
  try {
    const data = await AxiosInstance.postPostRequest(url, body, method);
    return success(data);
  } catch (error) {
    return failure(error);
  }
};
const getAPIRequest = async ({
  url,
  success,
  failure,
}: getRequestInterface) => {
  try {
    const data = await AxiosInstance.getRequest(url);
    success(data);
  } catch (error) {
    failure(error);
  }
};
const deleteAPI = async ({
  url,
  success,
  failure,
  body,
}: deleteRequestInterface) => {
  try {
    const data = await AxiosInstance.deleteRequest(url, body);
    success(data);
  } catch (error) {
    failure(error);
  }
};

const getAccessTokenOfNugget = async (
  userInfo: any,
  setAccessToken: (token: string) => void
) => {
  const data = {
    uid: userInfo?.id,
    clientId: 1,
    platform: "desktop",
    displayName: userInfo?.name,
    email: userInfo?.email,
  };

  const maxRetries = 5;
  let attempt = 0;
  let success = false;

  const token = localStorage.getItem("token");

  while (attempt < maxRetries && !success) {
    try {
      const response = await axios.post(`${BASE_URL}nugget`, data, {
        headers: {
          Authorization: `${token}`,
        },
      });

      const accessToken = response?.data?.data?.accessToken?.token;

      setAccessToken(accessToken);
      localStorage.setItem("nuggetAccessToken", accessToken);
      success = true; // Exit the loop if the request is successful
    } catch (error: any) {
      attempt++;
      if (error.response?.status || attempt >= maxRetries) {
        console.error(error);
        break; // Exit the loop if it's not a 500 error or max retries reached
      }
      console.warn(`Retrying... Attempt ${attempt}`);
    }
  }
};

const getUrlOfCoceptKundli = async (
  psid: string,
  setAccessUrl: (url: string) => void
) => {
  const maxRetries = 3;
  let attempt = 0;
  let success = false;
  while (attempt < maxRetries && !success) {
    try {
      const response = await axios.get(
        BASE_URL + GET_STUDENT_KUNDALI + "?psid=" + psid,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            reqMsgId: uuid(),
          },
        }
      );

      const accessToken = response?.data?.data?.insights_url;
      setAccessUrl(accessToken);
      success = true; // Exit the loop if the request is successful
    } catch (error: any) {
      attempt++;
      if (error.response?.status || attempt >= maxRetries) {
        console.error(error);
        break; // Exit the loop if it's not a 500 error or max retries reached
      }
      console.warn(`Retrying... Attempt ${attempt}`);
    }
  }
};
export {
  putPostRequest,
  getAPIRequest,
  deleteAPI,
  getAccessTokenOfNugget,
  getUrlOfCoceptKundli,
};
